import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodFish: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 12a6 6 0 0 0 6-6V0h-6a6 6 0 0 0-5.197 9H0a7 7 0 0 0 7 7v-4.803c.883.51 1.907.803 3 .803m3-7.75a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodFish
